import { motion } from 'framer-motion';
import { ArrowUp, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="contact" className="bg-[#0f0f0f] py-16 md:py-24 px-6 md:px-12 border-t border-gray-800 relative overflow-hidden">
      {/* Animated background */}
      <motion.div
        animate={{
          opacity: [0.02, 0.05, 0.02],
          scale: [1, 1.1, 1]
        }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
        className="absolute top-0 right-0 w-96 h-96 bg-orange-500 rounded-full blur-[120px]"
      />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <motion.img
              src="/logo.png"
              alt="Rukn Alfalah Technology Logo"
              className="h-20 w-auto object-contain mb-4"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            />
            <motion.h3
              className="text-white text-2xl font-bold mb-6 tracking-wider"
              whileHover={{ color: '#ff5722', scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              Rukn Alfalah Technology
            </motion.h3>
            <p className="text-gray-400 leading-relaxed">
              A digital agency focused on building elevated websites in Dubai.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="text-white text-lg font-semibold mb-6 tracking-wider">Contact</h4>
            <div className="space-y-4">
              <motion.a
                href="mailto:ayushaj11220@gmail.com"
                className="flex items-center gap-3 text-gray-400 hover:text-orange-500 transition-colors duration-300"
                whileHover={{ x: 5 }}
              >
                <Mail size={18} />
                <span>ayushaj11220@gmail.com</span>
              </motion.a>
              <motion.a
                href="tel:+971567472118"
                className="flex items-center gap-3 text-gray-400 hover:text-orange-500 transition-colors duration-300"
                whileHover={{ x: 5 }}
              >
                <Phone size={18} />
                <span>+971 56 747 2118</span>
              </motion.a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="text-white text-lg font-semibold mb-6 tracking-wider">Location</h4>
            <div className="flex items-start gap-3 text-gray-400">
              <MapPin size={18} className="mt-1 flex-shrink-0" />
              <address className="not-italic">
                Al Quasais Industrial Area 4, Dubai, UAE
              </address>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="pt-8 border-t border-gray-800 flex justify-between items-center"
        >
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Rukn Alfalah Technology. All rights reserved.
          </p>

          {/* Back to top button */}
          <motion.button
            onClick={scrollToTop}
            whileHover={{ scale: 1.1, backgroundColor: '#ff5722' }}
            whileTap={{ scale: 0.9 }}
            className="w-12 h-12 rounded-full border-2 border-gray-700 flex items-center justify-center text-gray-400 hover:text-white hover:border-orange-500 transition-all duration-300"
          >
            <ArrowUp size={20} />
          </motion.button>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
